import clsx from "clsx";
import React, { FC, DetailedHTMLProps, HTMLAttributes } from "react";

import styles from "./styles.module.scss";

export interface DividerProps
  extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  text?: string;
}

export const Divider: FC<DividerProps> = ({ text, className, ...props }) => {
  return (
    <div {...props} className={clsx(className, styles.divider)}>
      <div className={styles.bar}></div>
      <span>{text}</span>
      <div className={styles.bar}></div>
    </div>
  );
};
